import React from "react";
import SuperAdminSettingsNavbar from "../components/navbars/SuperAdminSettingsNavbar";
import { Outlet } from "react-router-dom";

export default function SettingsLayout() {
        return (
        <section className="main-layer-section">
            <SuperAdminSettingsNavbar />
            <section className="content-layer-section">
                <Outlet />
            </section>
        </section>
    );
}